/* global window */

export default function changeModule({ props }) {
  const { module } = props
  window.location.replace(
    `http://${window.location.host}/account/modules/change/${module}`
  )
}



// WEBPACK FOOTER //
// ./src/modules/App/actions/changeModule.js